import ListHybrid from "./ListHybrid";

/**
 * List automatically routes between the Tailwind implementation (preferred)
 * and the styled-components implementation (for consumers using system props
 * or a styled() extension).
 *
 * @example
 * <List as="ul">
 *   <ListItem>First</ListItem>
 *   <ListItem>Second</ListItem>
 * </List>
 */
const List = ListHybrid;

List.displayName = "List";

export default List;
